// REACT
import { useEffect, useState } from 'react';

// YARN
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

// SERVICES
import CultureGroupCard from './CultureGroupCard';
import useCultureGroupAction from 'utils/hooks/useCultureGroupAction';
import useAutoComplete from 'utils/hooks/useAutoComplete';

// THEMES
import { customButtonTheme } from 'assets/styles/themes/generic_button_mui';
import AddEditNonReturnCultureGroupModal from './AddEditNonReturnCultureGroup';

const NonReturnCultureGroup = ({
  ownerId,
  cultures,
  nonReturnCultureGroup,
  loadNonReturnCultureGroupData,
  from,
}) => {
  const [cultureGroupFiltered, setCultureGroupFiltered] = useState(nonReturnCultureGroup);
  const [modal, setModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const { t } = useTranslation();

  const formSuccess = async () => {
    setModal(false);
    setEditData(null);
    loadNonReturnCultureGroupData();
  };

  const { renderDeleteDialog, handleDeleteDialogOpen, handleEditDialogOpen } =
    useCultureGroupAction(
      ownerId,
      nonReturnCultureGroup,
      loadNonReturnCultureGroupData,
      setModal,
      setEditData,
      'nonReturnCultureGroup',
      from
    );

  const resetCultureGroupValue = () => {
    setInputValue('');
    setOptions(filterData('', nonReturnCultureGroup));
  };

  const { renderAutoComplete, inputValue, setInputValue, filterData, setOptions } = useAutoComplete(
    {
      data: nonReturnCultureGroup,
      getOptionLabel: (option) => option.name,
      resetValue: resetCultureGroupValue,
      isMetaculture: false,
    }
  );

  useEffect(() => {
    if (inputValue) {
      const filteredGroups = nonReturnCultureGroup?.filter((group) =>
        group.name.toLowerCase().includes(inputValue.toLowerCase())
      );
      setCultureGroupFiltered(filteredGroups);
    } else {
      setCultureGroupFiltered(nonReturnCultureGroup);
    }
  }, [inputValue, nonReturnCultureGroup]);

  return (
    <div className="section">
      <div>
        <div className="override">
          <div className="contain_header_icon search-actions-wrapper">
            {renderAutoComplete()}
            <ThemeProvider theme={customButtonTheme}>
              <Button
                onClick={() => {
                  setModal(!modal), setEditData(null);
                }}
              >
                {t('common.add')} <AddIcon />
              </Button>
            </ThemeProvider>
          </div>
        </div>
        <div className="card-container-cultureGroup">
          <CultureGroupCard
            cultureGroup={cultureGroupFiltered}
            onDeleteClick={handleDeleteDialogOpen}
            onEditClick={handleEditDialogOpen}
          />
        </div>
      </div>
      {modal && (
        <AddEditNonReturnCultureGroupModal
          modal={modal}
          setModal={setModal}
          onSubmitSuccess={formSuccess}
          edit={editData}
          ownerId={ownerId}
          cultures={cultures}
          cultureGroup={nonReturnCultureGroup}
          from={from}
        />
      )}
      {renderDeleteDialog()}
    </div>
  );
};

export default NonReturnCultureGroup;
